import React from 'react'
import { getId } from '../twd'

export default ({field, form, cls='', error, prefix='', suffix='', label, labelStyle,...props} = {}) => {
    const id = getId()

    let err = form.errors && form.errors[field.name]
    let style = { padding: '0 0 0 10px' }
    let isGroup = prefix || suffix
    return (
    <React.Fragment>
    {label && <label htmlFor={id} style={labelStyle}>{label}</label>}

    <div className={cls + (err || error ? ' has-error': '')}>
    <div className={ (isGroup ? 'input-group ' : '') + 'vertical-offset-xxs'} >
        {isGroup && <label className="input-group-addon" htmlFor={id}>{prefix}</label>}
        <input type="number"
            className='form-control'
            id={id}
            name={field.name}
            value={field.value}
            step="0.01"
            min="0"
            style={prefix ? {paddingLeft:'20px'} : style }
            {...field}
            {...props}
            {...(err || error ? {"aria-invalid":true} : {})}
            onChange={(e) =>{
                form.setFieldValue(field.name, e.target.value || '')
            }}
            />
            {isGroup && <label className="input-group-addon" htmlFor={id}>{suffix}</label>}
    </div>
    { err && <label className="field-status has-error">{err}</label> }
    </div>

    </React.Fragment>)
}